"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copilotCanRenameThread = copilotCanRenameThread;
// See tests
function copilotCanRenameThread(thread) {
    if (thread?.name) {
        if (thread.namedBy === "initializer") {
            return { ok: true };
        }
        return { ok: false, failureReason: "Thread already has a name." };
    }
    return { ok: true };
}
//# sourceMappingURL=helpers.js.map